import { colors, media } from 'settings/style';
import styled, { css } from 'styled-components';

export const StyledWrapper = styled.div`
  width: 100%;
  background: ${colors.white};
  border: 1px solid #e4e7ec;
  border-radius: 20px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
`;

export const StyledItem = styled.div`
  cursor: pointer;
  position: relative;
  break-inside: avoid;
`;

export const StyledItemWrapper = styled.div<{ isApproved?: boolean }>`
  ${({ isApproved }) =>
    !isApproved &&
    css`
      position: relative;
      &:before {
        content: '';
        display: block;
        background: #e4e2e2ad;
        position: absolute;
        width: 100%;
        height: 100%;
      }
    `}
`;

export const StyledImg = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  vertical-align: bottom;
  border-radius: 12px;
  display: block;
`;

export const VideoPlaceHolder = styled.div`
  width: 100%;
  height: 220px;
  background: ${`linear-gradient(200deg, ${colors.red100} 20%,${colors.primary200} 50%)`};
  border-radius: 12px;
  position: relative;
  .anticon {
    font-size: 64px;
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    margin-left: -40px;
    margin-top: -40px;
    &:hover {
      color: ${colors.primary300};
    }
  }
`;

export const ItemRemoveButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0;
  width: 35px;
  height: 35px;
  background-color: ${colors.red300};
  color: ${colors.white};
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  z-index: 9;
  /* border-top-right-radius: 0px; */
  margin: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.red400};
  }
`;

export const ApproveButton = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #06c049;
  color: #fff;
  border-radius: 5px;
  padding: 5px 12px;
  cursor: pointer;
  z-index: 10;
  margin: 10px;
  &:hover {
    background-color: #059f3c;
  }
`;

export const PendingApproval = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: ${colors.gray1400};
  color: #fff;
  border-radius: 5px;
  padding: 5px 12px;
  cursor: pointer;
  z-index: 10;
  margin: 10px;
`;

export const StyledUploadContainer = styled.div`
  display: inline-flex;
`;

export const StyledUploadWrap = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;

  input {
    position: absolute;
    width: 1px;
    opacity: 0;
    visibility: hidden;
    background-color: transparent;
  }
`;

export const MediaUploadButton = styled.button`
  font-size: 14px;
  text-align: center;
  vertical-align: middle;
  line-height: 20px;
  min-width: 128px;
  height: 40px;
  background-color: ${colors.grey900};
  color: ${colors.white};
  font-weight: 600;
  border: 1px solid ${colors.grey900};
  border-radius: 10px;
  padding: 0 16px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  &:hover {
    background-color: #475467;
    border-color: #475467;
  }
`;

export const ImportVideoButton = styled(MediaUploadButton)`
  background: ${colors.white};
  color: ${colors.grey900};
  border-color: #d0d5dd;

  &:hover {
    background: #f9fafb;
    border-color: #98a2b3;
    color: ${colors.grey900};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledAlbumWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  width: 100%;

  ${media.xl`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}

  ${media.md`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}

  ${media.xs`
    grid-template-columns: 1fr;
  `}
`;
